<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="정산 완료 조회"
      desc="정산 완료로 들어온 내역을 조회할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1400"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="partner_name" slot-scope="props">
        {{ props.item.partner_name }}
      </div>

      <div slot="acc_date" slot-scope="props">{{ props.item.acc_date }}</div>

      <div slot="total_price" slot-scope="props">
        {{ props.item.total_price | currency }}
      </div>

      <div slot="comm_price" slot-scope="props">
        {{ props.item.comm_price | currency }}
      </div>

      <div slot="coupon_price" slot-scope="props">
        {{ props.item.coupon_price | currency }}
      </div>

      <div slot="point" slot-scope="props">
        {{ props.item.point | currency }}
      </div>

      <div slot="acc_price" slot-scope="props">
        {{ props.item.acc_price | currency }}
      </div>

      <div slot="history" slot-scope="props">
        <button class="button" @click="openHistory(props.item.id)">내역보기</button>
      </div>

    </admin-table>

    <modal name="historyModal"
           :adaptive="true"
           :width="900"
           :height="600"
           style="overflow-y: scroll"
           class="modal-style">
      <div class="lp-modal-wrapper" v-if="detail">
        <div class="btn-group-justify-end" style="padding:0 12px">
          <i class="material-icons modal-exit" @click="$modal.hide('historyModal')">close</i>
        </div>
        <table class="table">
          <thead>
          <tr>
            <th>주문번호</th>
            <th>주문자</th>
            <th>상품명</th>
            <th>주문금액</th>
            <th>구매일</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(order,idx) in detail.orders" :key="'history-'+idx">
            <td>{{ order.order_num }}</td>
            <td>{{ order.order_name }}</td>
            <!-- 주문 상품 -->
            <td>
              <div class="flex align-center">
                <img :src="order.product_img" style="width:35px;height:35px;margin-right:6px" v-if="order.product_img">
                <div style="text-align: left">{{ order.product_name }}</div>
              </div>
            </td>
            <td>{{ order.total_price | currency }}</td>
            <td>{{ convertDate(order.created_time, 'datetime') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </modal>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  export default {
    name: 'AccountAll',
    components: {},
    mixins: [
      ListMixin
    ],
    data() {
      return {
        detail: undefined
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        // 정산 처리 안되어있는 경우 isnull=true
        this.initializing('account_all', 'booking/account');
        //this.filtered.acc_date=false;

        if(!this.isAdmin) {
          for(let i=0; i<this.filterData.length; i++) {
            let item = this.filterData[i];
            if(item.type==='search') {
              removeIndex(this.filterData,i);
            }
          }
        }
      },
      getDataFromServer() {
        this.getData();
      },
      openHistory(id) {
        this.$store.commit('setLoading', true);
        this.$axios.get(this.getUrl(`booking/account/${id}`)).then(res=> {
          this.$store.commit('setLoading', false);
          this.detail = res.data;
          this.$modal.show('historyModal');
        })
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
